import moment from 'moment';
import { EventTypes } from 'redux-segment';

import {
  CLIENTS_SMSTEXT_FAILURE,
  CLIENTS_SMSTEXT_REQUEST,
  CLIENTS_SMSTEXT_SUCCESS,
} from 'actions/sms/beGetClientSmsText.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import {
  BULK_DELETE_CLIENT_FAILURE,
  BULK_DELETE_CLIENT_REQUEST,
  BULK_DELETE_CLIENT_SUCCESS,
  BULK_OPTOUT_CLIENT_FAILURE,
  BULK_OPTOUT_CLIENT_REQUEST,
  BULK_OPTOUT_CLIENT_SUCCESS,
  CLEAR_TIME_RANGE,
  CLIENTS_COUNT_FAILURE,
  CLIENTS_COUNT_REQUEST,
  CLIENTS_COUNT_SUCCESS,
  CLIENTS_DATA_FAILURE,
  CLIENTS_DATA_REQUEST,
  CLIENTS_DATA_SUCCESS,
  FILTER_CLIENT_DATA_SUCCESS,
  FILTER_CLIENTS_DATA_FAILURE,
  FILTER_CLIENTS_DATA_REQUEST,
  FILTER_LAST_VISIT,
  FILTER_LOYALTY,
  FILTER_NEXT_VISIT,
  FILTER_SELECTED_STYLISTS,
  FILTER_SERVICES,
  FILTER_TIME_RANGE,
  GET_AUTO_MESSAGES_FAILURE,
  GET_AUTO_MESSAGES_REQUEST,
  GET_AUTO_MESSAGES_SUCCESS,
  GET_CAMPAIGN_BOOKINGS_FAILURE,
  GET_CAMPAIGN_BOOKINGS_REQUEST,
  GET_CAMPAIGN_BOOKINGS_SUCCESS,
  GET_CAMPAIGN_CLIENTS_FAILURE,
  GET_CAMPAIGN_CLIENTS_REQUEST,
  GET_CAMPAIGN_CLIENTS_SUCCESS,
  GET_MANUAL_MESSAGES_ONLY_FAILURE,
  GET_MANUAL_MESSAGES_ONLY_REQUEST,
  GET_MANUAL_MESSAGES_ONLY_SUCCESS,
  GET_MARKETING_CAMPAIGNS_FAILURE,
  GET_MARKETING_CAMPAIGNS_REQUEST,
  GET_MARKETING_CAMPAIGNS_SUCCESS,
  GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE,
  GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST,
  GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS,
  MARK_CLIENT_SELECT,
  PURCHASE_SMS_BUNDLE_FAILURE,
  PURCHASE_SMS_BUNDLE_REQUEST,
  PURCHASE_SMS_BUNDLE_SUCCESS,
  REST_BULK_DELETE_RESPONSE,
  SELECT_ALL_CLIENTS,
  SEND_MARKETING_SMS_FAILURE,
  SEND_MARKETING_SMS_REQUEST,
  SEND_MARKETING_SMS_SUCCESS,
  SET_AUTO_SMS_BY_MONTH,
  SET_HIDE_PHONE_VALUE,
  SET_MESSAGE_SENT,
  SET_OPT_VALUE,
  SET_SHOW_AUTOMSG_DETAILS,
  SET_SHOW_CAMPAIGN_DETAILS,
  SET_SMS_MESSAGE,
  SET_TIME_RANGE,
  SHOW_HIDE_NO_PHONE,
  SHOW_HIDE_OPT_CLIENTS,
  SORT_AUTO_MSG_CLIENT_LIST,
  SORT_AUTO_MSG_LIST,
  SORT_AUTO_SMS_BY_MONTH,
  SORT_CAMPAIGN_CLIENT_LIST,
  SORT_CAMPAIGN_LIST,
  SORT_CLIENT_LIST,
} from 'clientCommunications/constants';

// FIXME: delete this and use one of the actions in src/actions/sms
export const setRebookText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_rebook_prompt_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const setThankyouText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_thank_you_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const setNewClientText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_new_client_thank_you_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const set7weekText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_lapsed_7_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const set12weekText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_lapsed_12_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const set24weekText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_lapsed_24_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const setBdayText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sms_bday_clients_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisableRebook = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_rebook_prompt_text: disableOrEnable, sms_rebook_prompt_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisableThankyou = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_thank_you_text: disableOrEnable, sms_thank_you_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisableNewClient = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        enable_sms_new_client_thank_you_text: disableOrEnable,
        sms_new_client_thank_you_text: text,
      }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisable7Week = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_lapsed_7_weeks_text: disableOrEnable, sms_lapsed_7_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisable12Week = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_lapsed_12_weeks_text: disableOrEnable, sms_lapsed_12_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisable24Week = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_lapsed_24_weeks_text: disableOrEnable, sms_lapsed_24_weeks_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const enableDisableBday = (salonId, disableOrEnable, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enable_sms_bday_clients_text: disableOrEnable, sms_bday_clients_text: text }),
    },
  },
});

// FIXME: delete this and use one of the actions in src/actions/sms
export const setDepositText = (salonId, text) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/smstext/`,
    authenticated: true,
    types: [CLIENTS_SMSTEXT_REQUEST, CLIENTS_SMSTEXT_SUCCESS, CLIENTS_SMSTEXT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ deposit_request_text: text }),
    },
  },
});

// end
export const getAllClientsCount = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/client/count/`,
    authenticated: true,
    types: [CLIENTS_COUNT_REQUEST, CLIENTS_COUNT_SUCCESS, CLIENTS_COUNT_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const getClientsCancelledLastMonth = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/client/cancelations/`,
    authenticated: true,
    types: [CLIENTS_DATA_REQUEST, CLIENTS_DATA_SUCCESS, CLIENTS_DATA_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const getAllClientsPhoneList = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/client/withphone/`,
    authenticated: true,
    types: [CLIENTS_DATA_REQUEST, CLIENTS_DATA_SUCCESS, CLIENTS_DATA_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const getAllClientsList = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/client/list/`,
    authenticated: true,
    types: [CLIENTS_DATA_REQUEST, CLIENTS_DATA_SUCCESS, CLIENTS_DATA_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

// 'bucket': 'lost' | 'active' | 'first_time' | 'recent' | 'upcoming' | 'birthday' | 'all'      all-> list
export const getClientsCalculatedList = (salonId, apiSuffix) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/client/${apiSuffix}/?now=${moment().startOf('day')}`,
    authenticated: true,
    types: [CLIENTS_DATA_REQUEST, CLIENTS_DATA_SUCCESS, CLIENTS_DATA_FAILURE],
    params: { method: 'GET', salonId },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
  },
});

export const markClientSelect = (clientId, mark) => ({ type: MARK_CLIENT_SELECT, clientId, mark });
export const markAllClientsSelect = (mark) => ({ type: SELECT_ALL_CLIENTS, mark });
export const showOnlyOptedClients = (mark) => ({ type: SHOW_HIDE_OPT_CLIENTS, mark });
export const hideNoPhoneClients = (hide) => ({ type: SHOW_HIDE_NO_PHONE, hide });
export const setSmsMessage = (message, numOfMessages) => ({ type: SET_SMS_MESSAGE, message, numOfMessages });
export const setMessageSent = (tf) => ({ type: SET_MESSAGE_SENT, tf });

export const sendMarketingSMS = (data, salonId) => {
  const bucket = data?.bucket;
  const dataCopy = { ...(data ?? void 1) };

  dataCopy.length = data.numOfMessages;
  delete dataCopy.numOfMessages;

  if (bucket === 'one_to_one' || 'all' === bucket) delete dataCopy.appointment;
  if ('withphone' === bucket) dataCopy.bucket = 'with_phones';
  if ('cancelations' === bucket) dataCopy.bucket = 'canceled_last_month';

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/marketing/sms/send/`,
      authenticated: true,
      types: [SEND_MARKETING_SMS_REQUEST, SEND_MARKETING_SMS_SUCCESS, SEND_MARKETING_SMS_FAILURE],
      params: { data: dataCopy, method: 'POST' },
      config: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...dataCopy }),
      },
      meta: { analytics: EventTypes.track },
    },
  };
};

export const filterData = (salonId, apiSuffix, selectedStylistIds, selectedServices, lastDatesSelected) => {
  let urlsTring = '';
  if (selectedStylistIds.length > 0) {
    urlsTring = '?stylist=';
    selectedStylistIds.forEach((stylistId) => {
      if (urlsTring === '?stylist=') {
        urlsTring += stylistId;
      } else {
        urlsTring += `&stylist=${stylistId}`;
      }
    });
  }

  if (selectedServices.length > 0) {
    if (urlsTring === '') {
      urlsTring = '?service=';
    }
    selectedServices.forEach((service) => {
      if (urlsTring === '?service=') {
        urlsTring += service.id;
      } else {
        urlsTring += `&service=${service.id}`;
      }
    });
  }
  // (?P<salon_id>[0-9]+)/marketing/client/invalid_patch_test/
  const calcUrl = `salon/v2/${salonId}/marketing/client/${apiSuffix}/${urlsTring}`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: calcUrl,
      authenticated: true,
      types: [FILTER_CLIENTS_DATA_REQUEST, FILTER_CLIENT_DATA_SUCCESS, FILTER_CLIENTS_DATA_FAILURE],
      params: { method: 'GET', salonId, selectedStylistIds, lastDatesSelected },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
};

export const filterStylist = (selectedStylistIds) => ({ type: FILTER_SELECTED_STYLISTS, selectedStylistIds });
export const filterService = (selectedServices) => ({ type: FILTER_SERVICES, selectedServices });
export const filterLastVisit = (option) => ({ type: FILTER_LAST_VISIT, option });
export const filterNextVisit = (option) => ({ type: FILTER_NEXT_VISIT, option });
export const filterTimeRange = () => ({ type: FILTER_TIME_RANGE });
export const filterLoyalty = (isAnyAmount, amount, isAnyNumber, number) => ({
  type: FILTER_LOYALTY,
  isAnyAmount,
  amount,
  isAnyNumber,
  number,
});
export const setTimeRange = (fromDate, toDate) => ({ type: SET_TIME_RANGE, fromDate, toDate });
export const clearLastDatesSelected = () => ({ type: CLEAR_TIME_RANGE });
export const setOptChecked = (optValue) => ({ type: SET_OPT_VALUE, optValue });
export const setHidePhoneChecked = (isHideValue) => ({ type: SET_HIDE_PHONE_VALUE, isHideValue });
export const sortClientList = (tableRow, isAsc) => ({ type: SORT_CLIENT_LIST, tableRow, isAsc });

export const getUniqClients = (data, salonId) => {
  const bucket = data?.bucket;
  const dataCopy = { ...(data ?? {}) };

  if ('one_to_one' === bucket || 'all' === bucket) delete dataCopy.appointment;
  if ('withphone' === bucket) dataCopy.bucket = 'with_phones';
  if ('cancelations' === bucket) dataCopy.bucket = 'canceled_last_month';

  dataCopy.length = data.numOfMessages;
  delete dataCopy.numOfMessages;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/marketing/sms/estimate/`,
      authenticated: true,
      types: [
        GET_UNIQUE_CLIENTS_ESTIMATE_REQUEST,
        GET_UNIQUE_CLIENTS_ESTIMATE_SUCCESS,
        GET_UNIQUE_CLIENTS_ESTIMATE_FAILURE,
      ],
      params: { data: dataCopy, method: 'POST' },
      config: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...dataCopy }),
      },
      meta: { analytics: EventTypes.track },
    },
  };
};

export function fetchMarketingCampaigns(salonId, start, end) {
  let url = `salon/v2/${salonId}/marketing/sms/`;
  if (start && end) {
    url = `salon/v2/${salonId}/marketing/sms/?start=${start}&end=${end}`;
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: url,
      authenticated: true,
      types: [GET_MARKETING_CAMPAIGNS_REQUEST, GET_MARKETING_CAMPAIGNS_SUCCESS, GET_MARKETING_CAMPAIGNS_FAILURE],
      params: { method: 'GET' },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
}

export function fetchManualMessagesOnlyCampaigns(salonId, start, end) {
  let url = `salon/v2/${salonId}/marketing/sms/direct/`;
  if (start && end) {
    url = `salon/v2/${salonId}/marketing/sms/?start=${start}&end=${end}`;
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: url,
      authenticated: true,
      types: [GET_MANUAL_MESSAGES_ONLY_REQUEST, GET_MANUAL_MESSAGES_ONLY_SUCCESS, GET_MANUAL_MESSAGES_ONLY_FAILURE],
      params: { method: 'GET' },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
}

export function getCampaignMessageClients(messageId, salonId) {
  const url = `salon/v2/${salonId}/marketing/sms/${messageId}/recipients/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: url,
      authenticated: true,
      types: [GET_CAMPAIGN_CLIENTS_REQUEST, GET_CAMPAIGN_CLIENTS_SUCCESS, GET_CAMPAIGN_CLIENTS_FAILURE],
      params: { method: 'GET' },
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      meta: {
        analytics: EventTypes.track,
      },
    },
  };
}

// UNUSED: remove
export const getCampaignMessageBookings = (messageId, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/sms/${messageId}/bookings/`,
    authenticated: true,
    types: [GET_CAMPAIGN_BOOKINGS_REQUEST, GET_CAMPAIGN_BOOKINGS_SUCCESS, GET_CAMPAIGN_BOOKINGS_FAILURE],
    params: { method: 'GET' },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
    meta: { analytics: EventTypes.track },
  },
});

export const showCampaignDetails = (salonId, campaignId, show) =>
  show
    ? {
        [AUTH_API]: {
          api_root: CONF.apiRoot,
          endpoint: `salon/v2/${salonId}/marketing/sms/${campaignId}/recipients/`,
          authenticated: true,
          types: [GET_CAMPAIGN_CLIENTS_REQUEST, GET_CAMPAIGN_CLIENTS_SUCCESS, GET_CAMPAIGN_CLIENTS_FAILURE],
          params: { method: 'GET', campaignId, show, isAutoMsg: false },
          config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
          meta: { analytics: EventTypes.track },
        },
      }
    : { type: SET_SHOW_CAMPAIGN_DETAILS, campaignId, show };

export const sortCampaign = (row, isAsc) => ({ type: SORT_CAMPAIGN_LIST, row, isAsc });
export const sortAutoSmsByMonth = (row, isAsc) => ({ type: SORT_AUTO_SMS_BY_MONTH, row, isAsc });
export const sortCampaignClient = (row, isAsc, messageId) => ({
  type: SORT_CAMPAIGN_CLIENT_LIST,
  row,
  isAsc,
  messageId,
});
export const sortAutoMessages = (row, isAsc, campaignId) => ({ type: SORT_AUTO_MSG_LIST, row, isAsc, campaignId });
export const resetBulkDeleteResponse = () => ({ type: REST_BULK_DELETE_RESPONSE });
export const setAutoSmsByMonth = (autoSmsByMonth) => ({ type: SET_AUTO_SMS_BY_MONTH, autoSmsByMonth });
export const sortAutoMsgClient = (row, isAsc, messageId) => ({
  type: SORT_AUTO_MSG_CLIENT_LIST,
  row,
  isAsc,
  messageId,
});

export const fetchAutoMessages = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/marketing/sms/auto/`,
    authenticated: true,
    types: [GET_AUTO_MESSAGES_REQUEST, GET_AUTO_MESSAGES_SUCCESS, GET_AUTO_MESSAGES_FAILURE],
    params: { method: 'GET' },
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
    meta: { analytics: EventTypes.track },
  },
});

export const showAutoMsgDetails = (salonId, campaignId, show) =>
  show
    ? {
        [AUTH_API]: {
          api_root: CONF.apiRoot,
          endpoint: `salon/v2/${salonId}/marketing/sms/${campaignId}/recipients/`,
          authenticated: true,
          types: [GET_CAMPAIGN_CLIENTS_REQUEST, GET_CAMPAIGN_CLIENTS_SUCCESS, GET_CAMPAIGN_CLIENTS_FAILURE],
          params: { method: 'GET', campaignId, show, isAutoMsg: true },
          config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
          meta: { analytics: EventTypes.track },
        },
      }
    : { type: SET_SHOW_AUTOMSG_DETAILS, campaignId, show };

// Example: {'client_ids': [<client_id1>, <client_id2>]}
export const bulkDeleteClient = (salonId, clientIds, checkNotes) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/client/bulk/delete/`,
    authenticated: true,
    types: [BULK_DELETE_CLIENT_REQUEST, BULK_DELETE_CLIENT_SUCCESS, BULK_DELETE_CLIENT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ client_ids: clientIds, checkNotes }),
    },
    meta: { analytics: EventTypes.track },
  },
});

export const bulkOptoutClient = (salonId, clientIds) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/client/bulk/opt-out/`,
    authenticated: true,
    types: [BULK_OPTOUT_CLIENT_REQUEST, BULK_OPTOUT_CLIENT_SUCCESS, BULK_OPTOUT_CLIENT_FAILURE],
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ client_ids: clientIds }),
    },
    meta: {
      analytics: EventTypes.track,
    },
  },
});

// Example: data = {'bundle_count': 'fifty', 'five_hundreds', 'two_thousands'>, 'salon': <salon_id> }
export const purchaseSmsBundle = (data) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `billing/${data.salon}/purchase/sms/`,
    authenticated: true,
    types: [PURCHASE_SMS_BUNDLE_REQUEST, PURCHASE_SMS_BUNDLE_SUCCESS, PURCHASE_SMS_BUNDLE_FAILURE],
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) },
    meta: { analytics: EventTypes.track },
  },
});
